import { ServerFetch } from '../main-model'

export default class ShortcutProductListModel extends ServerFetch {
    getShortcutProductListBy = (data) => this.authFetch({
        url: 'shortcut-product-list/getShortcutProductListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}